export const ActionTypes={
    VERIFIED_SELLER:'VERIFIED_SELLER',
    QC_REQUEST_SEND:'QC_REQUEST_SEND',
    UPDATE_SELLER_MESSAGE_COUNT:"UPDATE_SELLER_MESSAGE_COUNT",
    ACTIVE_PRODUCT_COUNT:"ACTIVE_PRODUCT_COUNT",
    PRODUCT_ACTION_REQUIRED_COUNT:"PRODUCT_ACTION_REQUIRED_COUNT",
    UPADTE_QUESTION_COUNT:"UPADTE_QUESTION_COUNT",
    WALLET_AMOUNT:"WALLET_AMOUNT",
    LEAD_CHAT_COUNT:"LEAD_CHAT_COUNT",
    LEAD_COUNT:"LEAD_COUNT",
    TOTAL_LEAD_COUNT:"TOTAL_LEAD_COUNT",
    SHOW_HIDE_MENU:"SHOW_HIDE_MENU",
    BLOCKED_STATUS:"BLOCKED_STATUS",
    LEAD_SUBSCRIPTION:"LEAD_SUBSCRIPTION",//SL-710,
    GRAB_ORDER_POPUP:"GRAB_ORDER_POPUP" ,// SL-890
    SELLER_ADDRESS:"SELLER_ADDRESS",//SL-923
    NOTIFICATION_COUNT: "NOTIFICATION_COUNT",  // SL-
    BLOCKED_PRODUCTS_COUNT: "BLOCKED_PRODUCTS_COUNT",
    /** Latest `checkVendorFrozen` API response (see bootstrapVendorFrozenCheck.js) */
    VENDOR_FROZEN_CHECK_SUCCESS: "VENDOR_FROZEN_CHECK_SUCCESS",
    VENDOR_FROZEN_CHECK_RESET: "VENDOR_FROZEN_CHECK_RESET",
    /** Single bootstrap `auth.me` payload (see bootstrapSellerMe.js) */
    SELLER_ME_SUCCESS: "SELLER_ME_SUCCESS",
    SELLER_ME_RESET: "SELLER_ME_RESET",
    ORDER_COUNTS_BULK_FETCH_COMPLETE: "ORDER_COUNTS_BULK_FETCH_COMPLETE",
    ORDER_COUNTS_BULK_FETCH_RESET: "ORDER_COUNTS_BULK_FETCH_RESET",
    PRODUCT_COUNTS_BULK_FETCH_COMPLETE: "PRODUCT_COUNTS_BULK_FETCH_COMPLETE",
    PRODUCT_COUNTS_BULK_FETCH_RESET: "PRODUCT_COUNTS_BULK_FETCH_RESET",
    PRODUCT_OPPORTUNITY_COUNT: "PRODUCT_OPPORTUNITY_COUNT",
    RECOMMENDED_PRODUCT_OPPORTUNITY_COUNT: "RECOMMENDED_PRODUCT_OPPORTUNITY_COUNT",
}